import httpClient from './httpClient';

const baseEndpoint = '/api/shop/order'

const saveOrder = request => {
    return httpClient.post(`${baseEndpoint}/save`, request)
}

export {
    saveOrder
}
